'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Signal';

var EntypoSignal = function EntypoSignal(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M10,14c-1.094,0-1.981,0.894-1.981,2c0,1.104,0.887,2,1.981,2c1.094,0,1.98-0.896,1.98-2C11.98,14.895,11.094,14,10,14z M5.8,11.758l1.4,1.414c1.546-1.562,4.054-1.562,5.601,0l1.399-1.414C11.881,9.415,8.119,9.415,5.8,11.758z M3,8.928l1.4,1.414c3.092-3.123,8.106-3.123,11.199,0L17,8.928C13.135,5.024,6.865,5.024,3,8.928z M0.199,6.1l1.4,1.414c4.639-4.686,12.161-4.686,16.801,0L19.8,6.1C14.388,0.633,5.612,0.633,0.199,6.1z' })
    );
};

exports.default = EntypoSignal;
module.exports = exports['default'];